const UserAchievementsModule = () => {
  return <h4>유저 리그 기념샷 모듈</h4>;
};

export default UserAchievementsModule;
